import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';

export const Loader = ({
  updateAvailability, isVisible, Component, ...others
}) => {
  const { siteMap } = others;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  return isVisible ? (<Component {...others} />) : null;
};

Loader.propTypes = {
  Component: PropTypes.elementType.isRequired,
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const SiteMapElementLoader = React.memo(Loader);
